module.exports = __webpack_public_path__ + "aecb1b653f6d1ea3ee8d2b3e394a1d00.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/makeup-s.png
// module id = 2676
// module chunks = 0